import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import styles from './SpacePhotoGrid.module.css';

export interface SpacePhotoGridProps {
    images: string[];
}

export const SpacePhotoGrid: FC<SpacePhotoGridProps> = ({ images }) => {
    const { t } = useTranslation();
    const [openLightbox, setOpenLightbox] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const slides = images.map(image => ({
        src: image || '',
    }));

    const handleImageClick = (index: number) => {
        setCurrentImageIndex(index);
        setOpenLightbox(true);
    };

    const handleViewAllClick = () => {
        const startIndex = images.length > 2 ? 2 : images.length - 1;
        setCurrentImageIndex(startIndex);
        setOpenLightbox(true);
    };

    if (images.length === 0) {
        return (
            <div className={styles.placeholder}>
                <p>{t('space-detail-component.no-photos')}</p>
            </div>
        );
    }

    if (images.length === 1) {
        return (
            <div className={styles.singleImageContainer}>
                <img
                    src={images[0]}
                    alt="Foto do espaco"
                    className={styles.singleImage}
                    onClick={() => handleImageClick(0)}
                />
                <Lightbox
                    open={openLightbox}
                    close={() => setOpenLightbox(false)}
                    slides={slides}
                    index={currentImageIndex}
                    toolbar={{ buttons: ['close'] }}
                    controller={{ closeOnBackdropClick: true }}
                />
            </div>
        );
    }

    const hasMoreThanThreeImages = images.length >= 3;
    const hasThirdImage = images.length > 2;

    return (
        <div className={styles.gridContainer}>
            <div className={styles.mainImage}>
                <img
                    src={images[0]}
                    alt="Foto principal"
                    onClick={() => handleImageClick(0)}
                />
            </div>
            <div className={styles.sideImages}>
                <div className={styles.topImage}>
                    <img
                        src={images[1]}
                        alt="Foto secundaria"
                        onClick={() => handleImageClick(1)}
                    />
                </div>
                <div className={styles.bottomImage}>
                    {hasThirdImage ? (
                        <>
                            <img
                                src={images[2]}
                                alt="Foto terciaria"
                                onClick={() => handleImageClick(2)}
                            />
                            {hasMoreThanThreeImages && (
                                <button
                                    className={styles.viewAllButton}
                                    onClick={handleViewAllClick}
                                >
                                    {t('space-detail-component.view-all-photos')}
                                </button>
                            )}
                        </>
                    ) : (
                        <div className={styles.emptySlot} />
                    )}
                </div>
            </div>
            <Lightbox
                open={openLightbox}
                close={() => setOpenLightbox(false)}
                slides={slides}
                index={currentImageIndex}
                toolbar={{ buttons: ['close'] }}
                controller={{ closeOnBackdropClick: true }}
            />
        </div>
    );
};
